export default function MyText(props){
    return(
        <div {...props} style={{...styles.defaultStyle, ...props.style}}>{props.children}</div>
    )
}
const styles = {
    defaultStyle: {
        fontFamily: 'como',
        color: "#282d68"
    },
};